<template>
  <span class="grid-table__cell text-body-1 text-secondary-5 q-px-sm" :class="{ 'full-row': fullRow }">
    <slot />
    <LmTooltip v-if="!noTooltip" :delay="1000"><slot></slot></LmTooltip>
  </span>
</template>

<script>
export default {
  props: {
    fullRow: Boolean,
    noTooltip: Boolean
  }
}
</script>

<style lang="scss" scoped>
.grid-table__cell {
  height: 100%;
  line-height: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &.full-row {
    grid-column: 1/-1;
  }
}
</style>
